import r from"qs";import{isPlainObject as t}from"./isPlainObject.js";const e=r=>{let e;try{e=JSON.parse(r)}catch{return}if(t(e))return e},o=t=>r.parse(t);export{e as getObjectFromSerializedString,o as getParsedQuery};
//# sourceMappingURL=object.helpers.js.map
